export const serverPath = 'https://cheddar-third-tote.glitch.me/'